import { useQuery } from "@tanstack/react-query"
import { useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"

import { AdminPageHeader } from "@/components/AdminPageHeader"
import { Input } from "@/components/ui/input"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"
import { api } from "@/lib/client"
import { queryKeys } from "@/lib/queryKeys"
import { ADMIN_TABLE_CLASSNAME, ADMIN_TABLE_HEAD_TH, ADMIN_TABLE_ROW } from "@/lib/table"

export function CustomersPage() {
  const navigate = useNavigate()
  const [q, setQ] = useState("")
  const customers = useQuery({
    queryFn: () => api.customers(),
    queryKey: queryKeys.customers,
  })
  const rows = useMemo(() => {
    const list = customers.data?.customers ?? []
    const needle = q.trim().toLowerCase()
    if (!needle) return list
    return list.filter(
      (c) =>
        c.name.toLowerCase().includes(needle) ||
        (c.email ?? "").toLowerCase().includes(needle) ||
        (c.phone ?? "").includes(needle),
    )
  }, [customers.data, q])

  return (
    <div>
      <AdminPageHeader description="People who have placed Haute orders" title="Customers">
        <Input className="w-56" onChange={(e) => setQ(e.target.value)} placeholder="Search" value={q} />
      </AdminPageHeader>
      <div className="overflow-hidden rounded-lg border border-border">
        <Table className={ADMIN_TABLE_CLASSNAME}>
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              <TableHead className={ADMIN_TABLE_HEAD_TH}>Name</TableHead>
              <TableHead className={ADMIN_TABLE_HEAD_TH}>Email</TableHead>
              <TableHead className={ADMIN_TABLE_HEAD_TH}>Phone</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {customers.isPending ? (
              <TableRow>
                <TableCell className="text-muted-foreground" colSpan={3}>
                  Loading…
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell className="text-muted-foreground" colSpan={3}>
                  No customers yet.
                </TableCell>
              </TableRow>
            ) : (
              rows.map((customer) => (
                <TableRow
                  className={ADMIN_TABLE_ROW}
                  key={customer.id}
                  onClick={() => navigate(`/customers/${customer.id}`)}
                >
                  <TableCell className="font-medium">{customer.name || "—"}</TableCell>
                  <TableCell>{customer.email || "—"}</TableCell>
                  <TableCell className="text-muted-foreground">{customer.phone || "—"}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
